import useGetState from './use-get-state.js';
/**
 * This hook provides synchronous access to a service response and will keep
 * the previous response while loading.
 *
 * @template SVC
 * @param {({
 *     serviceState: IServiceState<SVC>|IAnonymousServiceState<SVC>,
 *     defaultValue?: SVC['response'],
 *   })} {
 *     serviceState,
 *     defaultValue,
 *   }
 * @returns
 */
export const useGetServiceResponse = (serviceState, defaultValue) => {
    return useGetState(serviceState.response, defaultValue);
};
export default useGetServiceResponse;
//# sourceMappingURL=use-get-service-response.js.map